(function () {
  if (window.LpNovaCapsulasScroll) return;
  window.LpNovaCapsulasScroll = true;

  var reduzir = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var seletores = [
    ".lp-nova-capsulas-hero__media",
    ".lp-nova-capsulas-hero__copy",
    ".lp-nova-capsulas-hero__capsula",
    ".lp-nova-capsulas-provas__card",
    ".lp-nova-capsulas-evolucao__copy",
    ".lp-nova-capsulas-evolucao__media",
    ".lp-nova-capsulas-evolucao__texto",
    ".lp-nova-capsulas-mudou__olho",
    ".lp-nova-capsulas-mudou__titulo",
    ".lp-nova-capsulas-mudou__comparacao",
    ".lp-nova-capsulas-mudou__crema",
    ".lp-nova-capsulas-mudou__grito",
    ".lp-nova-capsulas-mudou__resultado",
    ".lp-nova-capsulas-aluminio__card",
    ".lp-nova-capsulas-linhas__intro",
    ".lp-nova-capsulas-linhas__trilho",
    ".lp-nova-capsulas-embalagens__olho",
    ".lp-nova-capsulas-embalagens__cena",
    ".lp-nova-capsulas-embalagens__titulo",
    ".lp-nova-capsulas-embalagens__pilha",
    ".lp-nova-capsulas-embalagens__texto",
    ".lp-nova-capsulas-vitrine__titulo",
    ".lp-nova-capsulas-vitrine__trilho",
    ".lp-nova-capsulas-oficio__olho",
    ".lp-nova-capsulas-oficio__faixa",
    ".lp-nova-capsulas-oficio__titulo",
    ".lp-nova-capsulas-oficio__card",
    ".lp-nova-capsulas-duvidas__titulo",
    ".lp-nova-capsulas-duvidas__linha",
    ".lp-nova-capsulas-duvidas__item"
  ];

  function visivel(el) {
    var caixa = el.getBoundingClientRect();
    return caixa.top < window.innerHeight * 0.9 && caixa.bottom > 0 && caixa.left < window.innerWidth && caixa.right > 0;
  }

  function secoes(raiz) {
    var base = raiz && raiz.querySelectorAll ? raiz : document;
    var lista = [];
    if (base.matches && base.matches("section[class*='lp-nova-capsulas-']")) lista.push(base);
    base.querySelectorAll("section[class*='lp-nova-capsulas-']").forEach(function (secao) {
      lista.push(secao);
    });
    return lista;
  }

  var observador = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (entrada) {
      if (!entrada.isIntersecting) return;
      entrada.target.classList.add("is-revelado");
      observador.unobserve(entrada.target);
    });
  }, { threshold: 0.18, rootMargin: "0px 0px -8% 0px" });

  function preparar(raiz) {
    if (reduzir) return;
    secoes(raiz).forEach(function (secao) {
      var alvos = [];
      seletores.forEach(function (seletor) {
        secao.querySelectorAll(seletor).forEach(function (el) {
          if (el.getAttribute("data-lp-revelar") === "1") return;
          el.setAttribute("data-lp-revelar", "1");
          alvos.push(el);
        });
      });

      var grupos = new Map();
      alvos.forEach(function (el) {
        var pai = el.parentElement;
        if (!grupos.has(pai)) grupos.set(pai, []);
        grupos.get(pai).push(el);
      });

      grupos.forEach(function (lista) {
        lista.forEach(function (el, indice) {
          if (indice) el.style.setProperty("--lp-atraso", indice * 80 + "ms");
          if (visivel(el)) el.classList.add("is-revelado");
          else observador.observe(el);
        });
      });

      secao.classList.add("lp-nova-capsulas-motion");
    });
  }

  function soltar(raiz) {
    if (!raiz || !raiz.querySelectorAll) return;
    raiz.querySelectorAll("[data-lp-revelar]").forEach(function (el) {
      observador.unobserve(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { preparar(document); });
  } else {
    preparar(document);
  }

  document.addEventListener("shopify:section:load", function (evento) {
    preparar(evento.target);
  });

  document.addEventListener("shopify:section:unload", function (evento) {
    soltar(evento.target);
  });
})();
